const RefParser = require('json-schema-ref-parser')
const xhr = require('xhr')

const schemas = (window.schemas = {})
const validators = {}
const ptr = require('json-ptr')

const addSchema = (ajv, schemaId) => {
  return new Promise((resolve, reject) => {
    if (schemas[schemaId] != null) {
      resolve(schemas[schemaId])
    } else {
      xhr({ method: 'GET', url: schemaId, json: true }, (error, response) => {
        if (error != null) reject(error)
        RefParser.dereference(response.body, {
          parse: { file: false },
          resolve: { file: false }
        })
          .then((schema) => {
            if (schemaId === schema.$id) {
              ajv.addSchema(schema, schemaId)
              schemas[schemaId] = schema
              resolve(schema)
            } else {
              const subSchema = ptr.get(schema, schemaId.replace(schema.$id, ''))
              ajv.addSchema(subSchema, schemaId)
              schemas[schemaId] = subSchema
              resolve(subSchema)
            }
          })
          .catch(reject)
      })
    }
  })
}

const getSchema = (ajv, schemaId) => {
  const schema = schemas[schemaId]
  return schema || {}
}
const getValidator = (ajv, schemaId) => {
  if (!validators[schemaId]) {
    validators[schemaId] = ajv.getSchema(schemaId)
  }
  const validator = validators[schemaId]
  return validator
}

const pointerize = ($id) => {
  return $id
}

const schemaHelper = {
  addSchema,
  getSchema,
  getValidator,
  pointerize
}
module.exports = schemaHelper
